import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    confirm(event) {
        if (!window.confirm(this.data.get("message"))) {
            event.preventDefault()
        }
    }
}
